import React, { useState } from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Flex,
  HStack,
  Text,
  VStack,
  IconButton,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Button,
} from '@chakra-ui/react';
import { FiMenu, FiPlus } from 'react-icons/fi';
import SaktiSidebar from '../components/SaktiSidebar';
import SaktiBkmFilterBar from '../components/SaktiBkmFilterBar';
import SaktiBkmKpiCards from '../components/SaktiBkmKpiCards';
import SaktiBkmTable from '../components/SaktiBkmTable';
import SaktiBkmSimulation from '../components/SaktiBkmSimulation';
import SaktiBkmDetailModal from '../components/SaktiBkmDetailModal';
import { useSaktiBkmDashboard } from '../hooks/useSaktiBkmDashboard';
import { SAKTI_UI_SIZE } from '../uiSizes';
import { SaktiBkmListItem } from '../types';

const SaktiBkmPage: React.FC = () => {
  const {
    options,
    loadingOptions,
    loadingKpi,
    loadingTable,
    draftFilters,
    kpi,
    rows,
    pagination,
    tableError,
    simulationData,
    loadingSimulation,
    onDraftFilterChange,
    applyFilters,
    goToPage,
    fetchSimulation,
  } = useSaktiBkmDashboard();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedItem, setSelectedItem] = React.useState<SaktiBkmListItem | null>(null);

  const [view, setView] = useState<'list' | 'simulation'>('list');

  const { 
    isOpen: isMobileSidebarOpen, 
    onOpen: onMobileSidebarOpen, 
    onClose: onMobileSidebarClose 
  } = useDisclosure();

  const handleStartSimulation = () => {
    if (draftFilters.division_id) {
      fetchSimulation(draftFilters.division_id, draftFilters.date);
      setView('simulation');
    } else {
      alert('Pilih Divisi terlebih dahulu untuk simulasi');
    }
  };

  return (
    <Box minH="100vh" bg="#ECEEF1">
      <Flex align="stretch">
        <Box display={{ base: 'none', xl: 'block' }}>
          <SaktiSidebar activeMenu="bkm" />
        </Box>

        <Drawer isOpen={isMobileSidebarOpen} placement="left" onClose={onMobileSidebarClose} size="xs">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton zIndex={10} color="gray.500" />
            <DrawerBody p={0}><SaktiSidebar activeMenu="bkm" /></DrawerBody>
          </DrawerContent>
        </Drawer>

        <Box flex={1} p={SAKTI_UI_SIZE.pagePadding}>
          <VStack align="stretch" spacing={SAKTI_UI_SIZE.sectionGap}>
            <HStack justify="space-between" align={{ base: 'start', md: 'center' }} flexWrap="wrap">
              <HStack spacing={3} align="center">
                <IconButton aria-label="Menu" icon={<FiMenu />} variant="outline" bg="white" display={{ base: 'flex', xl: 'none' }} onClick={onMobileSidebarOpen} />
                <VStack align="start" spacing={0}>
                  <Text fontSize={SAKTI_UI_SIZE.pageTitle} fontWeight="bold" color="gray.900">BKM (Basis Kerja Mandor)</Text>
                  <Text color="gray.600" fontSize="sm">Total HA pemanen per blok per hari</Text>
                </VStack>
              </HStack>
              {view === 'list' && (
                <Button leftIcon={<FiPlus />} colorScheme="green" size="sm" onClick={handleStartSimulation}>Simulasi Proporsi</Button>
              )}
            </HStack>

            {view === 'list' ? (
              <>
                <SaktiBkmFilterBar filters={draftFilters} options={options} onFiltersChange={onDraftFilterChange} onApply={applyFilters} isApplying={loadingOptions || loadingTable} />
                <SaktiBkmKpiCards loading={loadingKpi || loadingOptions} data={kpi} />

                {tableError && <Alert status="warning" borderRadius="lg"><AlertIcon />{tableError}</Alert>}

                <SaktiBkmTable
                  loading={loadingTable || loadingOptions}
                  rows={rows}
                  pagination={pagination}
                  onPageChange={goToPage}
                  onViewDetail={(id) => {
                    const item = rows.find(r => r.id === id);
                    if (item) {
                      setSelectedItem(item);
                      onOpen();
                    }
                  }}
                  onEdit={(id) => console.log('Edit', id)}
                />
              </>
            ) : (
              <SaktiBkmSimulation
                data={simulationData}
                loading={loadingSimulation}
                onBack={() => setView('list')}
              />
            )}
          </VStack>
        </Box>
      </Flex>

      <SaktiBkmDetailModal
        isOpen={isOpen}
        onClose={onClose}
        data={selectedItem}
      />
    </Box>
  );
};

export default SaktiBkmPage;
